export const LOG = 'LOG' as const;
export const TOGGLE_LOG_OVERLAY = 'TOGGLE_LOG_OVERLAY' as const;

export const log = (message: string, logType: string) => ({
  type: LOG,
  payload: {
    message,
  },
  metadata: {
    logType,
  },
});

export const toggleLogOverlay = () => ({
  type: TOGGLE_LOG_OVERLAY,
});
